import { isFilteredPostFeed } from "../../../shared/src/post-feed";

/**
 * Addresses a click opens as a whole document instead of navigating within the site: the
 * dashboard and member apps (their own React apps), the payment page (its own referrer policy and
 * payment form), the API and provider callbacks, Start's own data and build files, and anything
 * with a file extension.
 */
const wholeDocument =
  /^\/(?:app|api|rpc|billing|checkout|dashboard|onboarding|customize|customization|integrations|_app|_start|_drate|_serverFn)(?:\/|$)|\.[a-z0-9]+$/i;

/** Whether a path on this site is one of its pages, which the router renders in place. */
export function sitePage(pathname: string) {
  return !wholeDocument.test(pathname);
}

/**
 * A feature index visited with what only its native page handles: a search or filter, or a
 * course or content checkout on Membership. Those show the native page even when the creator
 * composed one.
 */
export function nativeFeatureQuery(pathname: string, search: URLSearchParams) {
  if (pathname === "/blog") return isFilteredPostFeed(search);
  if (pathname === "/library") return search.has("collection") || search.has("q");
  if (pathname === "/merch" || pathname === "/shop")
    return search.has("category") || search.has("q");
  if (pathname === "/join") return search.has("course") || search.has("content");
  return false;
}
